import React, { Component } from 'react';
import {Input,Modal, Form,Icon, Button, Select,Radio, DatePicker, InputNumber } from 'antd';
import {getWorkflow,getTask,getTaskwithoutworkflow} from '../../stores/APIEndpoints';
import looseLeafStore from "../../stores/LooseLeafStore";
import DashboardArbitratorStore from '../../stores/DashboardArbitratorStore';
import {appStore} from '../../stores/AppStore';
import {inject, observer} from 'mobx-react';
import '../../../src/index.css';
import moment from 'moment';
let slectmulDates = [];
@inject('dataStore')
@observer
class LooseLeafArbitratorSchedulerDrawer extends Component {
  
    constructor(props) {
        super(props);
        this.apiProxy = appStore.apiProxy;
        this.state = {
            selectWorkflow:'',
            selectTasks:'',
            selectedMultipleDates:[],
            visible: false,
            basedonatask:'BASEDONATASK',
            basedonthelastupdatedate:'BASEDONTHELASTUPDATEDATE',
            fixed:'FIXED',

          }
    }
    get store() {
        return DashboardArbitratorStore;
      
    }
    async componentDidMount() {
    
        this.getTaskList();
        this.getWorkflowList();
        this.getMultipleList();
     
      }  
      getMultipleList = async()=>{
      
        const data = this.store.currentData;
        if(data.reseedFixedDates != null)
        {
        const reseedFixedDates = data.reseedFixedDates.split(',');
        if(reseedFixedDates[0]=="")
        {
          return;
        }
        slectmulDates = reseedFixedDates;
        this.setState({selectedMultipleDates:reseedFixedDates})
      
        }
      }
      getWorkflowList = async () => {
        const bodyParams = { "select": ["id", "name" ], "where": []};
        let response = await this.apiProxy.asyncPost(getWorkflow, bodyParams);
        const option = await response.json();
        this.setState({selectWorkflow:option});
     //   this.getTaskList();
      };
      // getTaskList = async() =>{
      //   const data = this.store.looseLeafSeed;
      //   if(data.globalWorkflowId != null)
      //   {
      //     const bodyParams = {"where": [data.globalWorkflowId]}
      //     let response = await this.apiProxy.asyncPost(getTask, bodyParams);
      //     const option = await response.json();
      //     this.setState({selectTasks:option});
      //   }
      // }
      
      getTaskList = async() =>{
        const data = this.store.currentData;
        const bodyParams = { "select": ["id", "name" ], "where": []};
          let response = await this.apiProxy.asyncPost(getTaskwithoutworkflow, bodyParams);
          const option = await response.json();
          this.setState({selectTasks:option});
        
      }




  handleSubmit = e => {
   
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
          let data={};
          data.globalWorkflowId =values.globalWorkflowId;
          data.reseedType = values.reseedType;
          data.projectStartDate = values.projectStartDate;
          if(values.projectStartDate !="" &&  values.projectStartDate != undefined)
          {
             //data.projectStartDate = values.projectStartDate.year()+'-'+(values.projectStartDate.month()+1)+'-'+values.projectStartDate.date();
             data.projectStartDate = moment(values.projectStartDate).format('YYYY-MM-DD');
            }
          else
          {
            this.store.currentData.projectStartDate = null;
            data.projectStartDate=null;
          }
          if(values.lastUpdatedDate !="" &&  values.lastUpdatedDate != undefined)
          {
            data.lastUpdatedDate = values.lastUpdatedDate.year()+'-'+(values.lastUpdatedDate.month()+1)+'-'+values.lastUpdatedDate.date();
          }
          else{
            this.store.currentData.lastUpdatedDate = null;
            data.lastUpdatedDate =null;
          }
              data.msAbstractTaskId = values.msAbstractTaskId;
              data.msActor = 'Project Manager';
         // data.ifpDate = values.ifpDate;
          // data.cmpDate = values.cmpDate;
          if(data.reseedType == 'FIXED')
          {
             data.reseedFixedDates=values.reseedFixedDatesList.toString();
             data.recyclePeriod = 0;
          }
          else
          {
              data.abstractTaskId = values.abstractTaskId;
              data.recyclePeriod = values.recyclePeriod;
          }
          data.preReview = values.preReview;
          data.p1Status = values.p1Status;
          data.newsAlert = values.newsAlert;
          data.wip_authorNames =this.store.currentData.authorNames;
          data.wip_authorEmails = this.store.currentData.authorEmails;
          data.wip_cmNames = this.store.currentData.cmNames;
          data.wip_cmEmails = this.store.currentData.cmEmails;
          data.wip_freelancerNames = this.store.currentData.freelancerNames;
          data.wip_freelancerEmails = this.store.currentData.freelancerEmails;
          this.store.updateItem(data);
     
      }
    });
  };
  onclickFinalized= e =>{
 
    this.props.form.validateFields((err, values) => {
      if (!err) {
          let data={};
         
          data.globalWorkflowId=values.globalWorkflowId;
          data.reseedType= values.reseedType;
          if(values.projectStartDate !="")
          {
            //data.projectStartDate = values.projectStartDate.year()+'-'+(values.projectStartDate.month()+1)+'-'+values.projectStartDate.date();
            data.projectStartDate = moment(values.projectStartDate).format('YYYY-MM-DD');
            // data.filesToAuthorDate = values.filesToAuthorDate.year()+'-'+(values.filesToAuthorDate.month()+1)+'-'+values.filesToAuthorDate.date();
            // data.filesFromAuthorDate = values.filesFromAuthorDate.year()+'-'+(values.filesFromAuthorDate.month()+1)+'-'+values.filesFromAuthorDate.date();
          }
          data.msAbstractTaskId = values.msAbstractTaskId;
          data.msActor = 'Project Manager';

          // data.ifpDate = values.ifpDate;
          // data.cmpDate = values.cmpDate;

          if(data.reseedType == 'FIXED')
          {
          data.reseedFixedDates=values.reseedFixedDatesList.toString();
          }
          else
          {
          data.abstractTaskId = values.abstractTaskId;
          data.recyclePeriod = values.recyclePeriod;
        }
        this.store.saveScheduleInfo(data)
     
      }
   
  });
}


  onChangeReseedType=(value)=>{
     this.store.currentData.reseedType = value; 
  }
  selectReseedFixedDates = (value) =>{
    slectmulDates.push('YYYY-'+(value.month()+1)+'-'+value.date());
    this.setState({selectedMultipleDates:slectmulDates});
    //this.setState({selectedMultipleDates:[...this.state.selectedMultipleDates, value._d.toLocaleDateString()]});
  }
  selectedDatesChange = (value) => {
    slectmulDates=[];
    slectmulDates=value;
    this.setState({selectedMultipleDates:slectmulDates});
  }
//  onChangeWorkflow=(value)=>{
//    const data = this.store.currentData;
//    data.globalWorkflowId  = value;
//    this.getTaskList(); 
//  }
//  getRequestDate=async(value)=>{
//    if(this.store.looseLeafSeed.abbreviation != "MIP")
//    {
//       this.store.looseLeafSeed.filesToAuthorDate=value;
//       this.getFileToAuthor(value);
//    }
//    else if(this.store.looseLeafSeed.abbreviation == "MIP")
//    {
//     const newdate = new Date(value);
//     let dateCount = await this.mapToWorkdays(newdate, 15);
//     let filesToAuthorDate = new Date(newdate.setDate(newdate.getDate() + dateCount));
//     this.store.looseLeafSeed.filesToAuthorDate=filesToAuthorDate
//     this.getFileToAuthor(filesToAuthorDate);
//    }
//  }
onchangeRecyclePeriod=async(values)=>{
  this.store.currentData.recyclePeriod = values;
}
onChangeLastUpdatedDate=async(values)=>{
  
  const newdate = new Date(values);
  if(this.store.currentData.reseedType == "BASEDONTHELASTUPDATEDATE")
     {
       if(this.store.currentData.recyclePeriod == 0 || this.store.currentData.recyclePeriod == "" || this.store.currentData.recyclePeriod == undefined ||  this.store.currentData.recyclePeriod == null)
       {
        message.error('Recycle period count is empty.');
        return false;
       }
      let dateCount = await this.mapToWorkdays(newdate, this.store.currentData.recyclePeriod);
      this.store.currentData.projectStartDate=new Date(newdate.setDate(newdate.getDate() + dateCount));
     }
 }
 mapToWorkdays=async(date, add)=> {
  const wd = this.weekday(date)
  
  let r = Math.trunc(add / 5) * 2
  const rem = add % 5

  if (wd > 4) r += (6-wd)
  else if (wd+rem > 4) r += 2
  
  return add + r;
}
weekday=(date)=> { return (date.getUTCDay()+ 6) % 7 }


  render() {
     const { getFieldDecorator } = this.props.form;
     const data = this.store.currentData;
   
     const title = data.id === undefined ? "New Title" : data.abbreviation + " - " + data.publication;
     const {selectWorkflow,selectTasks,} = this.state;
    // const reseedFixedDates = data.reseedFixedDates.split(',');
    
    // if(reseedFixedDates != null)
    // {
    // this.setState({selectedMultipleDates:reseedFixedDates})
    // }BASEDONATASK , BASED ON THE LAST UPDATE DATE
  
    
  
    return (
        <Form name="normal_login"  className="login-form" initialValues={{ remember: true }} onSubmit={this.handleSubmit}>
      
        <Form.Item label="Workflow"  name="Workflow">
            {getFieldDecorator('globalWorkflowId', {
                 initialValue:data.globalWorkflowId,
                 rules: []
            })(
                <Select showSearch placeholder="Select a Workflow" optionFilterProp="children">
                {selectWorkflow != "" ? selectWorkflow.map(value =>  <Option value={value.id}>{value.name}</Option>) : <Option value=''>''</Option>}
                </Select>
            )}
        </Form.Item>
        
        <Form.Item label="Reseed Type"  name="ReseedType">
        {getFieldDecorator('reseedType', {
           initialValue:data.reseedType,
           rules: []
            })(
            <Select showSearch defaultValue="BASEDONATASK"  placeholder="Select a reseed type" optionFilterProp="children" onChange={this.onChangeReseedType}>
                <Option value={"BASEDONATASK"}>BASED ON A TASK</Option>
                <Option value={"FIXED"}>FIXED</Option>
                <Option value={"BASEDONTHELASTUPDATEDATE"}>BASED ON THE LAST UPDATE DATE</Option>
            </Select>
            )}
        </Form.Item>
        
             {data.reseedType == 'FIXED' ?       
         <Form.Item label="Reseed Fixed Dates" name="reseedFixedDatesList">
          {getFieldDecorator('reseedFixedDatesList', {
              initialValue: this.state.selectedMultipleDates,
              rules: [{required: true}]
              })(
            <Select mode="tags" onChange={this.selectedDatesChange.bind(this)}  style={{ width: '100%' }} placeholder="Select the dates" optionLabelProp="label">
              <Option value=''></Option>
           </Select>
            )}
        </Form.Item>:''}
     
       {data.reseedType == 'FIXED' ?       
            <Form.Item name="reseedFixedDates" >
              <DatePicker format={'YYYY-MM-DD'} onChange={this.selectReseedFixedDates}/>
         </Form.Item>:''}


         {data.reseedType == 'BASEDONATASK' ?  
         <Form.Item label="Based on the Task"  name="abstractTaskId">
         {getFieldDecorator('abstractTaskId', {
              initialValue:data.abstractTaskId,
              rules: [{required: true}]
            })(
            <Select showSearch placeholder="Select a task" optionFilterProp="children">
            {selectTasks != "" ? selectTasks.map(value =>  <Option value={value.id}>{value.name}</Option>) : <Option value=''>''</Option>}
            </Select>
            )}
        </Form.Item> : ''}
        {data.reseedType == 'BASEDONATASK' || data.reseedType == 'BASEDONTHELASTUPDATEDATE' ?  
        <Form.Item label="Recycle Period"  name="RecyclePeriod" >
         {getFieldDecorator('recyclePeriod', {
             initialValue:data.recyclePeriod,
             rules: [{required: true}]
            })(
             <InputNumber style={{ width: '100%' }} onChange={this.onchangeRecyclePeriod}/>
            )}
         </Form.Item> :''}
         <Form.Item label="Request Date"  name="RequestDate" >
            {getFieldDecorator('projectStartDate', {
                  initialValue:(data.projectStartDate != null ? moment(data.projectStartDate, 'YYYY-MM-DD'):'')
                })(
              <DatePicker style={{ width: '100%' }} disabled={data.projectId>0} format={'YYYY-MM-DD'} />
            )}
         </Form.Item>

        <Form.Item>
          <Button style={{"float":"right","margin-top":"10px"}} type="primary"  htmlType="submit" className="login-form-button">Update </Button>
        </Form.Item>
        {/* <Button style={{"float":"right","margin-top":"10px","color":"#fff","background-color":"green","border-color":"green"}} type="success" onClick={() => this.onclickFinalized()}>Finalize</Button><br/><br/> */}
      </Form>
     
    );
  }
}

export default Form.create({ name: 'normal_login' })(LooseLeafArbitratorSchedulerDrawer);

// export default WrappedNormalLoginForm;

